

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <img 
              src="/logo.jpeg" 
              alt="Carz Bazzar Logo" 
              width={120} 
              height={60} 
              className="mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Privacy Policy</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We collect information you provide directly to us, such as when you create an account, use our franchise services, or contact us for support.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Personal Information:</h3>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
              <li>Name and contact information (phone number, email address)</li>
              <li>Address and location information</li>
              <li>Company information (if applicable)</li>
              <li>GST number and business details</li>
              <li>Financial information for franchise agreements</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
              <li>Provide, maintain, and improve our franchise services</li>
              <li>Process franchise applications and agreements</li>
              <li>Send technical notices, updates, security alerts, and support messages</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Communicate with you about franchise opportunities and promotional offers</li>
              <li>Verify franchise partner eligibility and credentials</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">If you have any questions about this Privacy Policy, please contact us:</p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> carsbazzarmain@gmail.com</p>
              <p className="text-gray-700 mb-2"><strong>Phone:</strong> +91 9773460662</p>
              <p className="text-gray-700"><strong>Address:</strong> Carz Bazzar Franchise, India</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
